export default {
    /**
     * @description 配置显示在浏览器标签的title
     */
    title: '骏驰天下',

    /** 公司名称 */
    name: '厦门骏驰天下信息技术有限公司',
    /** 公司微信 */
    wechat: 'GZWjhsmart',
    /** 公司邮箱 */
    email: 'service@junchitx.com',
    /** 公司手机 */
    phone: '13616051826',
    /** 公司电话 */
    tel: '0592-5990580',
    /** 公司地址 */
    address: '厦门市思明区福兴国际中心1602单元',
    /** 备案号 */
    keepOnRecordIcp: '沪ICP备18041627号',

    /** 百度地图相关信息 */
    /*BDMapInfo: {
        longitude: 121.526896,
        latitude: 31.24022,
        title: '普联大厦',
        address: '浦东新区崂山路300号普联大厦1号楼5楼703'
    }*/
}



// WEBPACK FOOTER //
// ./src/config/index.js